module.exports = __webpack_public_path__ + "static/media/warning.35f413a9.svg";